// extracted by css-extract-rspack-plugin
export default {"ListViewMetadata_0":"ListItemsHeaderWithoutBulkActions-module__ListViewMetadata_0__mMrOF"};